import { render, staticRenderFns } from "./IssueCardDialog.vue?vue&type=template&id=56bba2b5&scoped=true"
import script from "./IssueCardDialog.vue?vue&type=script&lang=js"
export * from "./IssueCardDialog.vue?vue&type=script&lang=js"
import style0 from "./IssueCardDialog.vue?vue&type=style&index=0&id=56bba2b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bba2b5",
  null
  
)

export default component.exports